;
define("header_profile.tpl", function(){});

